import CryptoJS from 'crypto-js';

/**
 * 生成签名
 * @param {Object} parameters - 参数对象
 * @returns {string} 签名字符串
 */
function generateSignature(parameters) {
    // 自然排序
    function naturalSort(a, b) {
        const regex = /(\d+)|(\D+)/g; // 匹配数字和非数字部分
        const aParts = String(a).match(regex);
        const bParts = String(b).match(regex);

        for (let i = 0, len = Math.min(aParts.length, bParts.length); i < len; i++) {
            const aPart = aParts[i];
            const bPart = bParts[i];

            if (!isNaN(aPart) && !isNaN(bPart)) {
                // 如果是数字部分，按数值比较
                if (parseInt(aPart, 10) !== parseInt(bPart, 10)) {
                    return parseInt(aPart, 10) - parseInt(bPart, 10);
                }
            } else if (aPart !== bPart) {
                // 如果是非数字部分，按字符串比较
                return aPart.localeCompare(bPart);
            }
        }

        // 如果所有部分都相同，则按长度比较
        return aParts.length - bParts.length;
    }
    // 对参数对象进行排序
    let sortedKeys = Object.keys(parameters).sort(naturalSort);
    let sortedParameters = {};
    for (let key of sortedKeys) {
        if(key === 'c'){
            sortedParameters[key] = parameters[key].replace(/\//g, "%2F");
        }else{
            sortedParameters[key] = encodeURIComponent(parameters[key]);
        }
        
        
    }
    // 计算 accessKeySecret
    let accessKeySecret = CryptoJS.MD5('kdslife').toString();
    // 构建查询字符串
    let queryStr = '';
    let first = true;
    for (let key in sortedParameters) {
        if (first) {
            queryStr += `${key?.replace(/\[/g, "%5B")?.replace(/\]/g, "%5D")}=${sortedParameters[key]?.replace(/%20/g, "+")}`;
            first = false;
        } else {
            queryStr += `&${key?.replace(/\[/g, "%5B")?.replace(/\]/g, "%5D")}=${sortedParameters[key]?.replace(/%20/g, "+")}`;
        }
    }
    // console.log(queryStr,'here')
    // 计算签名
    let signature = CryptoJS.MD5(CryptoJS.MD5(queryStr).toString() + accessKeySecret).toString();
    return signature;
}

export default generateSignature;



